import axios from "axios";

export default {
    namespaced: true,
    state: {
        currentRecipe: {},
        liked: {}
    },
    mutations: {
        setLiked(state, val){
            if (val){
                state.liked = val
            }

        },
        convertData( state, obj ) {

            let data = obj.data;
            const rootState = obj.rootState;


            let text = "";
            //---------------------------------
            //Techniques
            if (data.techniques !== undefined) {
                const lengthTech = data.techniques.length - 1;
                for (let i = 0; i <= lengthTech; i++) {
                    if (i === lengthTech && i) {
                        text += " and " + data.techniques[i].title;
                    } else if (i) {
                        text += ", " + data.techniques[i].title;
                    } else {
                        text = data.techniques[i].title
                    }
                }
                data.techniques = text;
            }

            if (data.repeater !== undefined) {
                //---------------------------------
                //Garnish
                let i = 0;
                while (data.repeater["garnish_" + i + "_garnish"] !== undefined) {
                    data.garnish = data.repeater["garnish_" + i + "_garnish"].value + ", ";
                    i++;
                }
                if (data.garnish) {
                    data.garnish = data.garnish.replace(/,\s*$/, "");
                }
                //---------------------------------
                //directions
                i = 0;
                data.directions = [];
                while (data.repeater["directions_" + i + "_direction_steps"] !== undefined) {
                    data.directions.push(data.repeater["directions_" + i + "_direction_steps"].value);
                    i++;
                }

                //---------------------------------
                //ingredients ingredients_0_ingredient
                i = 0;
                data.ingredients = [];
                while (data.repeater["ingredients_" + i + "_ingredient"] !== undefined) {
                    data.ingredients.push(data.repeater["ingredients_" + i + "_ingredient"].value);
                    i++;
                }

                //---------------------------------
                //spirit
                i = 0;
                while (data.repeater["spirit_" + i + "_spirit_type"] !== undefined && data.repeater["spirit_" + i + "_spirit_type"].value) {

                    let $spirit_product = data.repeater["spirit_" + i + "_spirit_type"].value;
                    let $spirit_quantity = data.repeater["spirit_" + i + "_spirit_quantity"].value;
                    $spirit_product = $spirit_product.replace("-", " ");
                    let $spirit_unit = data.repeater["spirit_" + i + "_spirit_unit"].value;

                    let $spirit_ml = "";
                    if ($spirit_unit === "oz") {
                        let $ml_spirit_quantity = convert_to_ml($spirit_quantity);
                        $spirit_ml = ' (' + $ml_spirit_quantity + ' ml)';
                    }
                    let $spirit_string = $spirit_quantity + " " + $spirit_unit + $spirit_ml + " " + $spirit_product;
                    if ($spirit_product !== "") {
                        data.ingredients.push($spirit_string);
                    }

                    i++;
                }
                //---------------------------------
                //product product_0_product

                i = 0;
                while (data.repeater["product_" + i + "_product"] !== undefined) {

                    const $post_product = data.repeater["product_" + i + "_product"].value;
                    const $quantity = data.repeater["product_" + i + "_quantity"].value;
                    const $unit = data.repeater["product_" + i + "_unit"].value;

                    const $product = rootState.shared.preloaded.products.find( el => el.id==$post_product );

                    if (!$post_product || !$quantity || !$unit || !$product) {
                        i++;
                        continue;
                    }

                    let $product_ml = "";
                    if ($unit == "oz") {
                        const $ml_quantity = convert_to_ml($quantity);
                        $product_ml = ' (' + $ml_quantity + ' ml) ';
                    }

                    const $url = "/products/?product=" + $post_product;
                    let $product_string = $quantity + " " + $unit + $product_ml + " " + "<router-link :to='{ path: \"" + $url + "\" }'>" + $product.title + "</router-link>";

                    if ( data.repeater["product_" + i + "_equivalent_product"].value != "" ) {
                        let $equivalent_product  =  data.repeater["product_" + i + "_equivalent_product"];
                        let $equivalent_product_detailed_title = rootState.shared.preloaded.products.find( el => el.id==$equivalent_product );

                        if ($equivalent_product_detailed_title){
                            $product_string =  +  + ' or ' + $equivalent_product_detailed_title.title;
                        }
                    }
                    data.ingredients.push($product_string);
                    i++;
                }
                for (let x= 0; x< data.ingredients.length; x++){
                    data.ingredients[x] = "<span>" +  data.ingredients[x] + "</span>";
                }

                delete data.repeater;
            }




            if (obj.liked){
                state.liked[data.id]=data;
                window.localStorage.setItem("liked", JSON.stringify(state.liked));
            }else{
                state.currentRecipe = data;
            }


        }
    },
    actions: {
        getCurrent(store, id) {
            const url = store.rootState.shared.api_url;
            axios.get(url + "recipes/" + id)
                    .then(response => {
                        const data = {
                            rootState: store.rootState,
                            data: response.data
                        };
                        store.commit("convertData", data);

                    })
                    .catch(error => console.log(error))
        },
        likeRecipe(store, id) {
            const url = store.rootState.shared.api_url;
            axios.get(url + "recipes/" + id)
                    .then(response => {
                        const data = {
                            rootState: store.rootState,
                            data: response.data,
                            liked: true // save to liked instead of
                        };
                        store.commit("convertData", data);
                        //console.log(store.state.liked);
                    })
                    .catch(error => console.log(error))
        },
        sendLike(store, id) {
            const url = store.rootState.shared.api_url;
            axios.post(url + "liked/" + id)
        }
    },
    getters: {}
}


Math.fmod = function (a, b) {
    return Number((a - (Math.floor(a / b) * b)).toPrecision(8));
};

function convert_to_ml($oz) {

    let $ml = "";

    if (Math.fmod($oz, 1) != 0) {
        switch ($oz) {
            case .25:
                $ml = 7;
                break;
            case .5:
                $ml = 15;
                break;
            case 1.25:
                $ml = 37;
                break;
            case 1.5:
                $ml = 45;
                break;
            default:
                $ml = Math.round($oz * 29.57);
        }
    } else {
        $ml = $oz * 30;
    }

    return $ml;
}
